<template>
  <div class="m-l-50 m-t-30 w-500 formType">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="显示名" prop="title">
        <el-input v-model.trim="form.title" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model.trim="form.name" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="节点类型" prop="level">
        <el-radio-group v-model="form.level">
          <el-radio label="1" disabled>项目</el-radio>
          <el-radio label="2" disabled>模块</el-radio>
          <el-radio label="3" disabled>操作</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="父节点" prop="pid">
        <el-select v-model="form.pid" placeholder="父节点" class="w-200" disabled>
          <el-option :key="index" v-for="(item, index) in options" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="edit('form')" :loading="isLoading">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getWithInDetail, editRule, getWithInList } from '@/api/customer.js'
export default {
  data() {
    return {
      isLoading: false,
      form: {
        id: null,
        title: '',
        name: '',
        pid: null,
        level: null
      },
      options: [{ id: 0, name: '根节点' }],
      rules: {
        title: [
          { required: true, message: '请输入节点名称' }
        ],
        name: [
          { required: true, message: '请输入节点显示名' }
        ],
        level: [
          { required: true, message: '请选择节点类型' }
        ],
        pid: [
          { type: 'number', required: true, message: '请选择父级节点' }
        ]
      }
    }
  },
  methods: {
    // 编辑
    edit(form) {
      let id = this.$route.query.id
      this.$refs[form].validate((valid) => {
        if (valid) {
          editRule(this.form.title, this.form.name, id).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', '编辑成功')
              router.push('/home/administrative/rule-list')
            }
          })
          this.isLoading = !this.isLoading
        }
      })
    },
    // 获取权限列表
    getRules() {
      getWithInList().then((res) => {
        if (res.data.code === 0) {
          for (let item of res.data.data.list) {
            if (item.level !== 3) {
              this.options.push(item)
            }
          }
        }
      })
    },
    // 获取权限详情
    getRulesDetail() {
      let id = this.$route.query.id
      getWithInDetail(id).then((res) => {
        if (res.data.code === 0) {
          this.form.level = res.data.data.level + ''
          this.form.name = res.data.data.name
          this.form.title = res.data.data.title
          this.form.pid = res.data.data.pid
        }
      })
    }
  },
  created() {
    this.getRules()
    this.getRulesDetail()
  }
}
</script>
